document.addEventListener("DOMContentLoaded", function () {
  const steps = document.querySelectorAll(".RequstCreditFormStep");
  const progressBarColumns = document.querySelectorAll(".ProgressBarColumn");

  // Function to update the progress bar
  function updateProgressBar(currentStep, nextStep) {
    // Deactivate the current progress bar step
    progressBarColumns[currentStep - 1].classList.remove("active");

    // Activate the new progress bar step
    progressBarColumns[nextStep - 1].classList.add("active");
  }

  function validateStep(step) {
    const requiredFields = step.querySelectorAll("[required]");
    let isValid = true;
    console.log("requiresfield", requiredFields);

    requiredFields.forEach((field) => {
      // Check if the field is empty
      if (!field.value.trim()) {
        field.classList.add("required-field-color");
        isValid = false;
      } else {
        field.classList.remove("required-field-color");
      }

      // If the field is an email input, check for a valid email format
      if (field.type === "email" && field.value.trim()) {
        if (!field.validity.valid) {
          field.classList.add("required-field-color");
          isValid = false;
          alert("Please enter a valid email address.");
        } else {
          field.classList.remove("required-field-color");
        }
      }
    });

    return isValid;
  }

  // Function to scroll to the top of the page
  function scrollToNextStep(nextStep) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  // Event listener for next step
  document.querySelectorAll("[data-next-step]").forEach((button) => {
    button.addEventListener("click", function () {
      const currentStep = parseInt(
        this.closest(".RequstCreditFormStep").dataset.step
      );
      const nextStep = parseInt(this.dataset.nextStep);
      const step = steps[currentStep - 1];

      // Validate only the current step before moving to the next one
      if (validateStep(step)) {
        // Hide current step and show next step
        steps[currentStep - 1].classList.add("form-step-hidden");
        steps[nextStep - 1].classList.remove("form-step-hidden");

        // Update progress bar
        updateProgressBar(currentStep, nextStep);

        // Scroll to the top of the next step
        scrollToNextStep(nextStep);
      } else {
        alert("Please fill in all required fields before proceeding.");
      }
    });
  });

  // Event listener for previous step
  document.querySelectorAll("[data-prev-step]").forEach((button) => {
    button.addEventListener("click", function () {
      const currentStep = parseInt(
        this.closest(".RequstCreditFormStep").dataset.step
      );
      const prevStep = parseInt(this.dataset.prevStep);

      // Hide current step and show previous step
      steps[currentStep - 1].classList.add("form-step-hidden");
      steps[prevStep - 1].classList.remove("form-step-hidden");

      // Update progress bar
      updateProgressBar(currentStep, prevStep);

      // Scroll to the top of the previous step
      scrollToNextStep(prevStep);
    });
  });
});
